import React from 'react';
import intl from "react-intl-universal";
import {useRootStore, useAppState} from "@stores/AppStateContext";

import {ContextItemParams, ContextMenu} from '../../../components/ContextMenu';
import {PAGES} from "@stores/ViewStore";
import {logout} from "../../../../actions/app/logout";
import {useAuthService} from "@stores/AppStateContext";

export interface ProfileContextMenuProps {
    handleClose: () => void;
    onlyLogout: boolean;
}

export const ProfileContextMenu = (
    {
        handleClose,
        onlyLogout = false,
    }: ProfileContextMenuProps
) => {
    const rootStore = useRootStore();
    const appState = useAppState();
    const authService = useAuthService();

    const actions: ContextItemParams[] = [
        {
            onClick: () => {
                rootStore.view.openPageByName(PAGES.SETTINGS_PROFILE);
                handleClose();
            },
            text: intl.get('profile.header').d('Profile'),
            condition: !onlyLogout,
        },
        {
            onClick: () => {
                logout(appState, authService);
                handleClose();
            },
            text: intl.get('common.logout').d('Logout'),
        },
    ];

    return (
        <ContextMenu
            handleClose={handleClose}
            items={actions}
        />
    );
};
